import { msg } from '@lingui/core/macro';

import { UNDER_CONSTRUCTION_PATH } from '@/shared/config';
import { defineScreen } from '@/shared/screen';

// Destino de todo link para o que ainda não migrou do UYZY atual (U15): avisa dentro da casca, em vez
// de mandar para fora do app.
export const underConstructionScreen = defineScreen({
  id: 'underConstruction',
  path: UNDER_CONSTRUCTION_PATH,
  title: msg`Em construção`,
  description: msg`Avisa que a área pedida ainda não chegou ao novo UYZY e oferece voltar para a tela anterior ou ir para o início.`,
  place: { icon: 'construction', parent: 'home' },
  actions: [],
});
